export class ValidationService {
  static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
      let config = {
          'required': 'Dieses Feld darf nich leer bleiben',
          'invalidEmailAddress': 'Bitte tragen Sie eine gültige Email Adresse ein',
          'invalidPassword': 'Ungültiges Passwort. Das Passwort muss wenigstes 6 Zeichen enthalten',
          'minlength': `Minimale Länge:  ${validatorValue.requiredLength}`,
          'maxlength': `Maximale Länge:  ${validatorValue.requiredLength}`,          
          'pattern': 'Dieses Feld darf keine Sonderzeichen enthalten',
          'matchOther': 'Passwörter stimmen nicht überein',
          'unavailabelEmail': 'Email bereits vergeben'
      };

      return config[validatorName];
  }

  static emailValidator(control) {
      // RFC 2822 compliant regex
      if (control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
          return null;
      } else {
          return { 'invalidEmailAddress': true };
      }
  }

  static passwordValidator(control) {
    // {6,100}           - Assert password is between 6 and 100 characters
    // (?=.*[0-9])       - Assert a string has at least one number
    if (control.value.match(/^[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
        return null;
    } else {
        return { 'invalidPassword': true };
    }
  }

  static agbValidator(control) {
    // {6,100}           - Assert password is between 6 and 100 characters
    // (?=.*[0-9])       - Assert a string has at least one number
    if (control.value === true) {
        return null;
    } else {
        return { 'invalidDataprotection': true };
    }
  }  
}



// WEBPACK FOOTER //
// ./src/app/validation/register.validation.ts